module.exports = __webpack_public_path__ + "img/Order NetWork.a78a7974.svg";